import { render } from "./PatientNavigationDataTable.vue?vue&type=template&id=392d1c99&scoped=true&lang=pug"
import script from "./PatientNavigationDataTable.vue?vue&type=script&lang=js"
export * from "./PatientNavigationDataTable.vue?vue&type=script&lang=js"

import "./PatientNavigationDataTable.vue?vue&type=style&index=0&id=392d1c99&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-392d1c99"]])

export default __exports__